// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1I5K4","text":"SelectPayment_text__3BC7R","title":"SelectPayment_title__1Lu0-","btn":"SelectPayment_btn__3UZOA"};